import { useIsClusterDemoMode } from '@cast/infrastructure-demo';
import { useShouldLimitConsoleForReporting } from '@cast/shared-trial-ui';
import { computeState } from 'hooks/useEnableCastAiButtonState';
import { useOptimizeBannerVisibility } from '@cast/one-click-features-opsPilot-optimizationWizard';

import { useCluster } from '@cast/shared-cluster-context-data-access';
import { useIsOpsPilotEnabled } from '@cast/features-organization-shared-opspilot';

export const useClusterDashboardBanners = (): {
  activeBanner: 'performance' | 'optimize' | null;
  isLoading: boolean;
} => {
  const { cluster, isManaged, canBeManaged, isKentEligible } = useCluster();
  const { opsPilotStatus } = useIsOpsPilotEnabled();
  const isInDemoMode = useIsClusterDemoMode();
  const limitReportingConsole = useShouldLimitConsoleForReporting();
  const { hidden } = useOptimizeBannerVisibility();

  const { canBeEnabled, hasBeenEnabled } = computeState({
    cluster,
    isManaged,
    canBeManaged,
    isInDemoMode,
    isKentEligible,
  });

  const showPerformanceBanner = canBeEnabled && !hasBeenEnabled;

  if (showPerformanceBanner) {
    return { activeBanner: 'performance', isLoading: false };
  }

  if (limitReportingConsole) {
    return { activeBanner: null, isLoading: false };
  }

  return {
    activeBanner: !hidden && opsPilotStatus !== 'disabled' ? 'optimize' : null,
    isLoading: false,
  };
};
